"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.test_json_data = void 0;
exports.test_json_data = {
    api_key_user_id: 3,
    api_key_profile_id: 3,
    profile: "api_key",
    type: "student",
    campus: "2<<@>>Aveda Institute Maine<<@>>Aveda Institute Maine",
    programs: [
        {
            name: "Cosmetology",
            value: "Cosmetology"
        },
        {
            name: "Esthetician",
            value: "Esthetician"
        },
        {
            name: "Instructor - 600 Hr",
            value: "Instructor - 600 Hr"
        },
        {
            name: "Limited Barbering",
            value: "Limited Barbering"
        },
        {
            name: "Nail Technician",
            value: "Nail Technician"
        }
    ],
    firstName: "test",
    lastName: "tester",
    program: "Esthetician",
    phone: 9181281212,
    email: "teststudentavedamaine223@yopmail.com",
    dateEnrolled: "2025-05-21T04:00:00.000Z",
    dateGraduate: "2025-05-07T04:00:00.000Z",
    program_status: "Withdrawn",
    programStatusAnswer: "Withdrawn",
    method_receipt: "Email",
    methodReceiptAnswer: "Email"
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVzdF9qc29uX2RhdGEuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbIndyYXBwZXIvdGVzdF9qc29uX2RhdGEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxjQUFjLEdBQUc7SUFDMUIsZUFBZSxFQUFFLENBQUM7SUFDbEIsa0JBQWtCLEVBQUUsQ0FBQztJQUNyQixPQUFPLEVBQUUsU0FBUztJQUNsQixJQUFJLEVBQUUsU0FBUztJQUNmLE1BQU0sRUFBRSx1REFBdUQ7SUFDL0QsUUFBUSxFQUFFO1FBQ047WUFDSSxJQUFJLEVBQUUsYUFBYTtZQUNuQixLQUFLLEVBQUUsYUFBYTtTQUN2QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGFBQWE7WUFDbkIsS0FBSyxFQUFFLGFBQWE7U0FDdkI7UUFDRDtZQUNJLElBQUksRUFBRSxxQkFBcUI7WUFDM0IsS0FBSyxFQUFFLHFCQUFxQjtTQUMvQjtRQUNEO1lBQ0ksSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixLQUFLLEVBQUUsbUJBQW1CO1NBQzdCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsaUJBQWlCO1lBQ3ZCLEtBQUssRUFBRSxpQkFBaUI7U0FDM0I7S0FDSjtJQUNELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLFFBQVEsRUFBRSxRQUFRO0lBQ2xCLE9BQU8sRUFBRSxhQUFhO0lBQ3RCLEtBQUssRUFBRSxVQUFVO0lBQ2pCLEtBQUssRUFBRSxzQ0FBc0M7SUFDN0MsWUFBWSxFQUFFLDBCQUEwQjtJQUN4QyxZQUFZLEVBQUUsMEJBQTBCO0lBQ3hDLGNBQWMsRUFBRSxXQUFXO0lBQzNCLG1CQUFtQixFQUFFLFdBQVc7SUFDaEMsY0FBYyxFQUFFLE9BQU87SUFDdkIsbUJBQW1CLEVBQUUsT0FBTztDQUMvQixDQUFBIn0=